







import vue, {PropType} from 'vue';

export default vue.extend({
  name: 'PeriodAt',

  props: {
    startsAt: {
      required: true,
      type: Date as PropType<Date>,
    },
    endsAt: {
      required: false,
      type: Date as PropType<Date | null>,
    },
  },

  computed: {
    dateMessage(): string {
      return this.endsAt === null
          ? `Le ${this.startsAt.toLocaleDateString()}`
          : `Du ${this.startsAt.toLocaleDateString()} au&nbsp;${this.endsAt.toLocaleDateString()}`;
    },
    dateTitle(): 'Date' | 'Période' {
      return this.endsAt === null ? `Date` : `Période`;
    },
  },
});
